<template>
  <div>
    <Table
      :columns="columns"
      :data="resources"
      size="small"
      highlight-row
      stripe
      max-height="700"
    >
      <template slot-scope="{ row }" slot="imei">
        <span>
          {{ row.product_name_en ? row.product_name_en : 'N/A' }}
        </span>
        <br />
        <span>
          {{ row.imei ? '(' + row.imei + ')' : '' }}
        </span>
      </template>
      <template slot-scope="{ row }" slot="unit_price">
        <ts-display-currency
          :amount="row.input_unit_price"
          :currency_id="row.input_currency_id"
        />
      </template>
      <template slot-scope="{ row }" slot="fx_rate">
        <div class="text-right ts-text-blue-700 ts-font-semibold">
          {{ row.fx_rate }}
        </div>
      </template>
      <template slot-scope="{ row }" slot="total">
        <ts-display-currency
          :amount="row.input_total"
          :currency_id="row.input_currency_id"
        />
      </template>
      <template slot-scope="{ row }" slot="converted_total">
        <ts-display-currency
          :amount="row.total"
          :currency_id="row.currency_id"
        />
      </template>
    </Table>
  </div>
</template>
<script>
export default {
  name: 'tableExpand',
  props: {
    row: Object
  },
  data() {
    return {}
  },
  computed: {
    resources() {
      return this.row.details
    },
    columns() {
      return [
        {
          title: this.$t('expensePosting.expCategory'),
          key: 'exp_category',
          width: 170,
          sortable: true,
          tooltip: true
        },
        {
          title: this.$t('expensePosting.expCode'),
          key: 'exp_code',
          width: 145,
          sortable: true,
          tooltip: true
        },
        {
          title: this.$t('expensePosting.expItem'),
          key: 'exp_item',
          width: 170,
          sortable: true,
          tooltip: true
        },
        {
          title: this.$t('expensePosting.imei'),
          slot: 'imei',
          width: 160,
          sortable: true,
          tooltip: true
        },
        {
          title: this.$t('expensePosting.uom'),
          key: 'uom_name_en',
          width: 90,
          align: 'center',
          sortable: true
        },
        {
          title: this.$t('expensePosting.qty'),
          key: 'quantity',
          width: 100,
          align: 'center',
          sortable: true
        },
        {
          title: this.$t('expensePosting.amount'),
          slot: 'unit_price',
          width: 140,
          align: 'right',
          sortable: true
        },
        {
          title: this.$t('expensePosting.total'),
          slot: 'total',
          width: 140,
          align: 'right',
          sortable: true
        },
        {
          title: this.$t('expensePosting.convertedtotal'),
          slot: 'converted_total',
          width: 150,
          align: 'right',
          sortable: true
        },
        {
          title: this.$t('expensePosting.expenseBy'),
          key: 'expense_by_emp',
          width: 150,
          sortable: true,
          tooltip: true
        },
        {
          title: this.$t('expensePosting.purpose'),
          key: 'purpose',
          tooltip: true
        }
      ]
    }
  },
  methods: {}
}
</script>
